import LotStatusBlock from './lot-status-block';
export default LotStatusBlock;